if (!customElements.get('lens-drawer')) {
  class LensDrawer extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.productFormId = this.dataset.productFormId;
      this.cartAddUrl = this.dataset.cartAddUrl;

      this.overlay = this.querySelector('[data-lens-overlay]');
      this.panel = this.querySelector('.nitida-lens-drawer__panel');
      this.closeButton = this.querySelector('[data-lens-close]');
      this.submitButton = this.querySelector('[data-lens-submit]');
      this.errorElement = this.querySelector('[data-lens-error]');
      this.fileInput = this.querySelector('[data-lens-file]');
      this.multipartForm = this.querySelector('[data-lens-multipart-form]');
      this.options = this.querySelectorAll('[data-lens-option]');

      this.trigger = document.querySelector(`[aria-controls="${this.id}"]`);
      if (this.trigger) this.trigger.addEventListener('click', this.open.bind(this));

      this.overlay.addEventListener('click', this.close.bind(this));
      this.closeButton.addEventListener('click', this.close.bind(this));
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.submitButton.addEventListener('click', this.onSubmit.bind(this));

      this.pricesRefreshed = false;
    }

    open() {
      this.classList.add('nitida-lens-drawer--active');
      document.body.classList.add('overflow-hidden');
      trapFocus(this.panel, this.panel);
      this.refreshPrices();
    }

    close() {
      this.classList.remove('nitida-lens-drawer--active');
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.trigger);
    }

    showError(message) {
      this.errorElement.textContent = message;
      this.errorElement.hidden = false;
    }

    clearError() {
      this.errorElement.hidden = true;
      this.errorElement.textContent = '';
    }

    getSelectedLensVariantId() {
      const checked = this.querySelector('[data-lens-variant-id]:checked');
      return checked ? checked.value : null;
    }

    getFrameVariantId() {
      const input = document.querySelector(`#${this.productFormId} [name="id"]`);
      return input ? input.value : null;
    }

    getQuantity() {
      const input = document.querySelector(`#Quantity-Form-${this.sectionId} .quantity__input`);
      const value = input ? parseInt(input.value, 10) : NaN;
      return Number.isNaN(value) || value < 1 ? 1 : value;
    }

    generateBundleId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return 'bundle-xxxxxxxxxxxxxxxxxxxxxxxx'.replace(/x/g, () =>
        Math.floor(Math.random() * 16).toString(16)
      );
    }

    refreshPrices() {
  if (this.pricesRefreshed) return;
  this.pricesRefreshed = true;

  this.options.forEach((option) => {
    const handle = option.dataset.handle;
    if (!handle) return;

    const input = option.querySelector('[data-lens-variant-id]');
    const priceElement = option.querySelector('[data-lens-price]');
    if (!input || !priceElement) return;

    // No permitir agregar una variante mientras carga.
    input.value = '';
    input.disabled = true;

    fetch(`/products/${handle}.js`)
      .then((response) => {
        if (!response.ok) throw new Error('No se pudieron cargar los cristales.');
        return response.json();
      })
      .then((product) => {
        const variants = product.variants || [];
        const availableVariants = variants.filter((item) => item.available);
        const firstAvailable = availableVariants[0];

        if (!firstAvailable) {
          input.checked = false;
          option.classList.add('nitida-lens-drawer__option--unavailable');
          priceElement.textContent = window.variantStrings.soldOut;
          return;
        }

        input.disabled = false;
        option.classList.remove('nitida-lens-drawer__option--unavailable');
        priceElement.textContent = this.formatMoney(firstAvailable.price);

        const needsSelection =
          variants.length > 1 ||
          handle === 'cristales-organicos-fotocromaticos-de-colores';

        if (!needsSelection) {
          input.value = firstAvailable.id;
          return;
        }

        // Dejar la variante vacía hasta que el cliente elija.
        input.value = '';

        const container = document.createElement('div');
        container.style.gridColumn = '1 / -1';
        container.style.width = '100%';

        const caption = document.createElement('span');
        caption.textContent = 'Elegí el color del cristal';
        caption.style.display = 'block';

        const select = document.createElement('select');
        select.id = `lens-color-${this.sectionId}-${product.id}`;
        select.setAttribute('aria-label', 'Color del cristal');
        select.style.width = '100%';
        select.style.maxWidth = '100%';
        select.style.padding = '10px';
        select.style.marginTop = '8px';

        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Seleccioná un color';
        placeholder.selected = true;
        placeholder.disabled = true;
        select.appendChild(placeholder);

        variants.forEach((variant) => {
          const choice = document.createElement('option');
          choice.value = String(variant.id);
          choice.textContent =
            variant.title + (variant.available ? '' : ' (Agotado)');
          choice.disabled = !variant.available;
          select.appendChild(choice);
        });

        select.addEventListener('change', () => {
          const selected = variants.find(
            (variant) => String(variant.id) === select.value
          );

          if (!selected || !selected.available) {
            input.value = '';
            return;
          }

          input.value = String(selected.id);
          input.checked = true;
          priceElement.textContent = this.formatMoney(selected.price);
          this.clearError();
        });

        container.appendChild(caption);
        container.appendChild(select);
        option.appendChild(container);
      })
      .catch((error) => {
        console.error(error);
        input.value = '';
        input.disabled = true;
        input.checked = false;
        priceElement.textContent = 'No se pudo cargar. Recargá la página.';
      });
  });
}


    formatMoney(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: this.dataset.shopCurrency,
      });
    }

    onSubmit(evt) {
      evt.preventDefault();
      this.clearError();

      const frameVariantId = this.getFrameVariantId();
      const lensVariantId = this.getSelectedLensVariantId();

      if (!frameVariantId) {
        this.showError('No se pudo identificar el armazón seleccionado.');
        return;
      }
      if (!lensVariantId) {
        this.showError('Elegí un tipo de cristal para continuar.');
        return;
      }

      const quantity = this.getQuantity();
      const bundleId = this.generateBundleId();
      const hasFile = this.fileInput && this.fileInput.files && this.fileInput.files.length > 0;

      this.toggleLoading(true);

      if (hasFile) {
        this.addFrameOnly(frameVariantId, quantity, bundleId)
          .then(() => this.submitLensWithFile(lensVariantId, bundleId))
          .catch((e) => {
            console.error(e);
            this.showError(e.message || 'No se pudo agregar el armazón al carrito. Intentá de nuevo.');
            this.toggleLoading(false);
          });
        return;
      }

      this.addBundle(frameVariantId, quantity, lensVariantId, bundleId)
        .then((response) => {
          this.toggleLoading(false);
          this.close();
          this.renderCart(response);
        })
        .catch((e) => {
          console.error(e);
          this.showError(e.message || 'No se pudo agregar al carrito. Intentá de nuevo.');
          this.toggleLoading(false);
        });
    }

    toggleLoading(loading) {
      this.submitButton.classList.toggle('loading', loading);
      this.submitButton.querySelector('.loading__spinner').classList.toggle('hidden', !loading);
      if (loading) {
        this.submitButton.setAttribute('aria-disabled', 'true');
      } else {
        this.submitButton.removeAttribute('aria-disabled');
      }
    }

    getCartSections() {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      return cart ? cart.getSectionsToRender().map((section) => section.id) : [];
    }

    addBundle(frameVariantId, quantity, lensVariantId, bundleId) {
      const body = JSON.stringify({
        items: [
          {
            id: frameVariantId,
            quantity,
            properties: { _bundle_id: bundleId, _bundle_role: 'armazon' },
          },
          {
            id: lensVariantId,
            quantity: 1,
            properties: { _bundle_id: bundleId, _bundle_role: 'cristal' },
          },
        ],
        sections: this.getCartSections(),
        sections_url: window.location.pathname,
      });

      return fetch(this.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body,
      })
        .then((response) => response.json())
        .then((data) => this.rejectIfError(data));
    }

    rejectIfError(data) {
      if (data.status) {
        throw new Error(data.description || data.message);
      }
      return data;
    }

    addFrameOnly(frameVariantId, quantity, bundleId) {
      const body = JSON.stringify({
        id: frameVariantId,
        quantity,
        properties: { _bundle_id: bundleId, _bundle_role: 'armazon' },
      });

      return fetch(this.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body,
      })
        .then((response) => response.json())
        .then((data) => this.rejectIfError(data));
    }

    submitLensWithFile(lensVariantId, bundleId) {
      this.multipartForm.querySelector('[data-lens-multipart-variant-id]').value = lensVariantId;
      this.multipartForm.querySelector('[data-lens-multipart-bundle-id]').value = bundleId;
      this.multipartForm.submit();
    }

    renderCart(response) {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (typeof cart.renderContents === 'function') {
        cart.renderContents(response);
      }

      // The drawer keeps the `is-empty` class it was rendered with, which collapses
      // the items area and leaves only the footer visible. Same guard as product-form.js.
      cart.classList.remove('is-empty');

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'lens-drawer',
        cartData: response,
      });
    }
  }

  customElements.define('lens-drawer', LensDrawer);
}
